export default "__VITE_ASSET__7890ce42__"